// extracted by mini-css-extract-plugin
export default {"sponsers":"Sponsers_sponsers__I8bgg"};